import {createSelector} from 'reselect';
import guardedSelector from '../utils/guardedSelector';

import {getConditionalInstantBook} from './priceDetails';
import {getBookingType} from './listing';
import {getTravelerSegmentFeatures} from './travelerSegmentFeatures';
import {getIncompleteDates} from './tripDates';
import {getAbacusTests, getTranslations} from './store';
import {VRBO_PDP_MOBILE_PRICETRANSPARENCY} from '../abacus/experiments';
import {evaluationIsVariant} from '@homeaway/react-experiment';

const getPriceTransparencyTestOn = createSelector(
    [getAbacusTests],
    (abacusTests) => {
        return evaluationIsVariant(abacusTests[VRBO_PDP_MOBILE_PRICETRANSPARENCY], 1);
    }
);

const getBookButtonLabel = createSelector(
    [getTranslations, getConditionalInstantBook, getBookingType, getPriceTransparencyTestOn],
    (translations, conditionalInstantBook, bookingType, isMobilePriceTransparencyEnabled) => {
        const {onlineBookable, instantBook} = bookingType;
        let label;

        if (onlineBookable) {
            if (isMobilePriceTransparencyEnabled) {
                label =
                    instantBook || conditionalInstantBook
                        ? translations.propertyBookNowTest
                        : translations.propertyRequestToBook;
            } else {
                label =
                    instantBook || conditionalInstantBook
                        ? translations.propertyBookNow
                        : translations.propertyRequestToBook;
            }
        }

        return label || '';
    }
);

const getCheckAvailabilityLabel = createSelector(
    [getTranslations, getTravelerSegmentFeatures, getPriceTransparencyTestOn, getIncompleteDates],
    (translations, travelerSegmentFeatures, isMobilePriceTransparencyEnabled, incompleteDates) => {
        const {useCheckAvailabilityButton} = travelerSegmentFeatures;

        if (isMobilePriceTransparencyEnabled && incompleteDates) {
            return translations.checkAvailabilityTest;
        }
        return useCheckAvailabilityButton ? translations.checkAvailability : '';
    }
);

const getPrimaryCtaLabel = createSelector(
    [getTranslations, getBookButtonLabel, getCheckAvailabilityLabel],
    (translations, bookButton, checkAvailabilityButton) => {
        return (
            checkAvailabilityButton ||
            bookButton ||
            translations['internal-components.contact-host.call-to-action']
        );
    }
);

const getPrimaryCallToActionButton = guardedSelector(
    'getPrimaryCallToActionButton',
    createSelector(
        [getPrimaryCtaLabel, getBookingType],
        (primaryCtaLabel, bookingType) => {
            return {
                primaryCtaLabel,
                propertyOlb: bookingType.onlineBookable
            };
        }
    )
);

export default getPrimaryCallToActionButton;

export {
    getPrimaryCallToActionButton,
    getBookButtonLabel,
    getCheckAvailabilityLabel,
    getPrimaryCtaLabel,
    getPriceTransparencyTestOn
};
